"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterImageAttachments = exports.filterImageAttachments = void 0;
const react_1 = require("react");
const imageTypes = 'image/*,.jpeg,.jpg,.png,.gif';
const imageExtensions = imageTypes.split(',');
function filterImageAttachments(attachments) {
    return attachments.filter(attachment => {
        return imageExtensions.some(extension => {
            var _a, _b;
            return (((_a = attachment.url) === null || _a === void 0 ? void 0 : _a.includes(extension)) ||
                ((_b = attachment.name) === null || _b === void 0 ? void 0 : _b.includes(extension)));
        });
    });
}
exports.filterImageAttachments = filterImageAttachments;
// hook wrapper
function useFilterImageAttachments(attachments) {
    return (0, react_1.useMemo)(() => filterImageAttachments(attachments), [attachments]);
}
exports.useFilterImageAttachments = useFilterImageAttachments;
//# sourceMappingURL=useFilterImageAttachments.js.map